import apiClient from "@/axios";

export const getActiveUserPackage = async () => {
  const response = await apiClient.post(
    "/user/package/get-active-user-package"
  );
  return response;
};

export const getUserByEmail = async (email) => {
  const response = await apiClient.post("/user/by-email", { email });
  return response;
};

export const verifyEmail = async (token) => {
  const response = await apiClient.post("/email/verify", { token });
  return response;
}

export const sendVerificationEmail = async (email) => {
  const response = await apiClient.post("/user/email/verification-notification");
  return response;
}

export const Me = async () => {
  const response = await apiClient.post("/user/me");
  return response;
}